import React, { useState } from 'react';
import BlockPalette from './components/BlockPalette';
import BlockCanvas from './components/BlockCanvas';
import ExportPanel from './components/ExportPanel';
import './SecondPage.css';

interface PlacedBlock {
    x: number;
    y: number;
    texture: string;
}

const SecondPage: React.FC = () => {
    const [selectedTexture, setSelectedTexture] = useState<string | null>(null);
    const [placedBlocks, setPlacedBlocks] = useState<PlacedBlock[]>([]);

    const handleTextureSelect = (texture: string) => {
        setSelectedTexture(texture);
    };

    const handleBlocksChange = (blocks: PlacedBlock[]) => {
        setPlacedBlocks(blocks);
    };

    return (
        <div className="second-page-container">
            <header className="second-page-header">
                <h1>Block Layout Editor</h1>
                <p>Create block layouts that can be exported and used in your canvas.</p>
            </header>
            
            <main className="second-page-content">
                <div className="editor-layout">
                    <div className="left-panel">
                        <BlockPalette 
                            selectedTexture={selectedTexture}
                            onTextureSelect={handleTextureSelect}
                        />
                        
                        <BlockCanvas 
                            selectedTexture={selectedTexture}
                            onBlocksChange={handleBlocksChange}
                        />
                    </div>
                    
                    <div className="right-panel">
                        <ExportPanel blocks={placedBlocks} />
                    </div>
                </div>
                
                <section className="instructions-section">
                    <h2>How to Use</h2>
                    <div className="instructions-grid">
                        <div className="instruction-card">
                            <h3>1. Select Block</h3>
                            <p>Choose a block texture from the palette above.</p>
                        </div>
                        
                        <div className="instruction-card">
                            <h3>2. Place Blocks</h3>
                            <p>Click on the canvas to place blocks. Click existing blocks to remove them.</p>
                        </div>
                        
                        <div className="instruction-card">
                            <h3>3. Export Layout</h3>
                            <p>Copy the JSON configuration or download it to use in your Home.tsx file.</p>
                        </div>
                    </div>
                </section>
            </main>
        </div>
    );
};

export default SecondPage;